import { EventParamMap } from './types';
import { Subject } from 'rxjs';

const ApiError$ = new Subject<EventParamMap['API_ERROR']>();

export const watchApiError = () => ApiError$.asObservable();
export const publishApiError = (err: EventParamMap['API_ERROR']) => ApiError$.next(err);
